const asyncQuerySelectorAll = (selector, root = document, threshold = 5000) => {
  return new Promise((resolve, reject) => {
    try {
      const intervalTime = 100;
      let time = 0;
      const interval = setInterval(() => {
        if (time >= threshold) {
          clearInterval(interval);
          resolve([]);
        }

        const elements = [...root.querySelectorAll(selector)];

        if (elements.length) {
          clearInterval(interval);
          resolve(elements);
        }

        time += intervalTime;
      }, intervalTime);
    } catch (e) { 
      console.error(e) 
    }
  })
}

(async () => {
  const chargedWidget = await asyncQuerySelectorAll('.upcoming-order-details');
  if (chargedWidget) {
    chargedWidget.forEach(element => {
      const totalElem = element.querySelectorAll('.ro-translation-products_list_quantity');
      var total = 0;
      totalElem.forEach(e => {
        total += parseInt(e.innerText.replace(/\D/g, ""));
      });
      element.querySelector('.ro-translation-products_list_heading').textContent = total + ' ' + element.querySelector('.ro-translation-products_list_heading').textContent;
    });
  }
})();